// ----------------------------------------------------------------------

import Page from "../components/Page";

export default function Convert() {
  return <Page title="Convert">Convert</Page>;
}
